import React from 'react';
import DocsLink from '../../../common/custom/DocsLink';

const MultiTenant = () => {
  return (
    <>
      <h5>About Multi-tenant SaaS</h5>
      <p>
        Allows you to build a multi-tenant SaaS web app on DrapCode.
        It is a simple plugin that incorporate a readymade multi-tenant architecture in your web app.
      </p>
      <DocsLink
        link='https://academy.drapcode.com/docs/multi-tenant-saas-plugin/page-restrictions-in-multi-tenant-saas'
      />
      <br />
      <h5>Email Template</h5>
      <p>
        Multi-Tenant SaaS plugin allows you to send custom emails to different users. The use case that we have covered
        below shows how to install the multi-tenant SaaS plugin and then send custom email template through to two different users.
      </p>
      <DocsLink
        link='https://academy.drapcode.com/docs/multi-tenant-saas-plugin/email-template-in-multi-tenant-saas'
      />
    </>
  );
};

export default MultiTenant;
